document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initMarquesina();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initStickyCompra();
  initContadorOferta();
  initVistosRecientemente();
  initVisitasSimuladas();
  initToonhub();
  initHeroCarousel();
  initBestsellersCarousel();
  initCarrito();
  initCartDrawerScrollLock();
  // initCartTimer(); — el aviso de "carrito reservado 10 minutos" se retiró: no hay reserva real.
  initBarraPromo();
  initAnalyticsEventos();
  initPopups();
  initToasts();
});

/* ------------------------------------------------------------
   Analítica: capa de eventos (CRO)
   Cada evento se manda como CustomEvent 'sn:<evento>' (para debug/otros
   scripts) y como dataLayer.push (para GA4/GTM si están instalados).
   No inventa nada: solo envuelve acciones reales ya existentes.
------------------------------------------------------------ */
function snTrack(nombre, datos) {
  datos = datos || {};
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: 'sn_' + nombre }, datos));
  document.dispatchEvent(new CustomEvent('sn:' + nombre, { detail: datos }));
}
window.snTrack = snTrack;

function initAnalyticsEventos() {
  // add_to_cart real: se engancha a la llamada de red real que Dawn hace al
  // añadir (routes.cart_add_url), sin depender de qué componente la lance.
  if (!window.__snFetchParcheado) {
    window.__snFetchParcheado = true;
    var fetchOriginal = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var esAdd = url.indexOf('/cart/add') !== -1;
      var promesa = fetchOriginal.apply(this, arguments);
      if (esAdd) {
        promesa.then(function (res) {
          if (res && res.ok) {
            res.clone().json().then(function (item) {
              snTrack('add_to_cart', {
                product_id: item.product_id,
                variant_id: item.variant_id || item.id,
                title: item.product_title || item.title,
                quantity: item.quantity,
              });
            }).catch(function () {});
          }
        }).catch(function () {});
      }
      return promesa;
    };
  }

  // cart_drawer_open real: Dawn marca el <cart-drawer> con la clase
  // "active" cada vez que se abre (al añadir, o al pulsar el icono).
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    var estabaActivo = drawer.classList.contains('active');
    new MutationObserver(function () {
      var activo = drawer.classList.contains('active');
      if (activo && !estabaActivo) snTrack('cart_drawer_open', {});
      estabaActivo = activo;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // cross_sell_accepted: clic real en una tarjeta de "Podría gustarte"
  // dentro del carrito lateral.
  document.addEventListener('click', function (e) {
    var tarjeta = e.target.closest('.sn-drawer-podria-gustarte a');
    if (tarjeta) snTrack('cross_sell_accepted', { href: tarjeta.getAttribute('href') });
  });

  // checkout_start real: clic en el botón nativo de pago (formulario del
  // carrito, name="checkout") — el único paso hacia checkout que este tema
  // controla (Shopify no permite inyectar código dentro del checkout en
  // planes sin Checkout Extensibility).
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[name="checkout"]');
    if (boton) snTrack('checkout_start', {});
  });
}

/* ------------------------------------------------------------
   Barra de promoción real (sn-barra-promo): cuenta atrás + auto-ocultado
   al pasar la fecha de fin real de la promoción.
------------------------------------------------------------ */
function initBarraPromo() {
  var barra = document.querySelector('[data-sn-barra-promo]');
  if (!barra) return;
  var cuentaEl = barra.querySelector('[data-sn-barra-promo-cuenta]');
  var fin = new Date(barra.getAttribute('data-fin')).getTime();
  if (!fin || isNaN(fin)) return;

  function actualizar() {
    var restante = fin - Date.now();
    if (restante <= 0) {
      barra.closest('.sn-section, [id^="shopify-section-"]') && (barra.closest('[id^="shopify-section-"]').style.display = 'none');
      barra.style.display = 'none';
      clearInterval(temporizador);
      return;
    }
    var dias = Math.floor(restante / 86400000);
    var horas = Math.floor((restante % 86400000) / 3600000);
    var minutos = Math.floor((restante % 3600000) / 60000);
    if (!cuentaEl) return;
    if (dias > 0) cuentaEl.textContent = 'Termina en ' + dias + 'd ' + horas + 'h';
    else cuentaEl.textContent = 'Termina en ' + horas + 'h ' + minutos + 'm';
  }
  actualizar();
  var temporizador = setInterval(actualizar, 60000);
}

/* ------------------------------------------------------------
   Popups de conversión (captación + exit-intent + carrito)
   Reglas de frecuencia (documentadas también para el usuario):
   - Máximo 1 popup por sesión de navegación (nunca 2 en la misma visita).
   - Si se cierra sin suscribirse: no se vuelve a ofrecer hasta pasados 7 días.
   - Si se suscribe (código capturado): no se vuelve a mostrar el popup de
     captación nunca más en ese navegador.
   - Nunca se muestra si ya hay un popup abierto, ni en /cart ni si la
     sesión ya vio uno.
------------------------------------------------------------ */
function initPopups() {
  var overlay = document.querySelector('[data-sn-popup-overlay]');
  var popupBienvenida = document.getElementById('sn-popup-bienvenida');
  var popupCarrito = document.getElementById('sn-popup-carrito');
  if (!overlay || !popupBienvenida || !popupCarrito) return;

  var LS_DISMISS = 'sn_popup_dismissed_until';
  var LS_SUBSCRITA = 'sn_popup_subscrita';
  var SS_MOSTRADO = 'sn_popup_mostrado_sesion';

  function yaSuscrita() {
    try { return localStorage.getItem(LS_SUBSCRITA) === 'true'; } catch (e) { return false; }
  }
  function enPausa() {
    try {
      var hasta = parseInt(localStorage.getItem(LS_DISMISS) || '0', 10);
      return Date.now() < hasta;
    } catch (e) { return false; }
  }
  function marcarPausa() {
    try { localStorage.setItem(LS_DISMISS, String(Date.now() + 7 * 86400000)); } catch (e) {}
  }
  function yaMostradoEnSesion() {
    try { return sessionStorage.getItem(SS_MOSTRADO) === 'true'; } catch (e) { return false; }
  }
  function marcarMostradoEnSesion() {
    try { sessionStorage.setItem(SS_MOSTRADO, 'true'); } catch (e) {}
  }

  // Marca de visitante recurrente (solo para matizar el tono del popup,
  // nunca para inventar datos de compra: eso solo lo sabemos si ha iniciado
  // sesión, y eso ya lo resuelve el propio Liquid con {% if customer %}).
  var esRecurrente = false;
  try {
    esRecurrente = localStorage.getItem('sn_visitada_antes') === 'true';
    localStorage.setItem('sn_visitada_antes', 'true');
  } catch (e) {}
  if (esRecurrente) {
    var eyebrow = popupBienvenida.querySelector('[data-sn-popup-eyebrow]');
    if (eyebrow) eyebrow.textContent = 'Nos alegra verte de nuevo';
  }

  // Si venimos de enviar el formulario de newsletter con éxito, Shopify
  // recarga la página con el bloque "gracias" ya renderizado por Liquid.
  var gracias = popupBienvenida.querySelector('[data-sn-popup-gracias]');
  if (gracias) {
    try { localStorage.setItem(LS_SUBSCRITA, 'true'); } catch (e) {}
    if (!yaMostradoEnSesion()) {
      abrir(popupBienvenida);
      marcarMostradoEnSesion();
      if (!sessionStorage.getItem('sn_email_capturado_evento')) {
        snTrack('email_captured', {});
        try { sessionStorage.setItem('sn_email_capturado_evento', 'true'); } catch (e) {}
      }
    }
  }

  function abrir(popup) {
    // Nunca deben verse dos popups a la vez: si otro sigue abierto (p. ej.
    // por un cierre que no ha terminado su animación), se oculta ya.
    document.querySelectorAll('[data-sn-popup]').forEach(function (otro) {
      if (otro !== popup) {
        otro.hidden = true;
        otro.removeAttribute('data-sn-visible');
      }
    });
    overlay.hidden = false;
    popup.hidden = false;
    requestAnimationFrame(function () {
      overlay.setAttribute('data-sn-visible', '');
      popup.setAttribute('data-sn-visible', '');
    });
    snTrack('popup_shown', { tipo: popup.getAttribute('data-sn-popup-tipo') });
  }

  function cerrar(popup) {
    overlay.removeAttribute('data-sn-visible');
    popup.removeAttribute('data-sn-visible');
    setTimeout(function () {
      overlay.hidden = true;
      popup.hidden = true;
    }, 250);
    snTrack('popup_closed', { tipo: popup.getAttribute('data-sn-popup-tipo') });
  }

  document.querySelectorAll('[data-sn-popup-cerrar]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var popup = btn.closest('[data-sn-popup]');
      marcarPausa();
      cerrar(popup);
    });
  });
  overlay.addEventListener('click', function () {
    document.querySelectorAll('[data-sn-popup][data-sn-visible]').forEach(function (p) {
      marcarPausa();
      cerrar(p);
    });
  });
  document.querySelectorAll('[data-sn-popup-cta]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var popup = btn.closest('[data-sn-popup]');
      snTrack('popup_cta_click', { tipo: popup.getAttribute('data-sn-popup-tipo') });
    });
  });

  // Si ya se mostró algo esta sesión (incluida la de "gracias" de arriba),
  // no se instala ningún disparador nuevo.
  if (yaMostradoEnSesion()) return;
  // Nunca en el propio carrito/checkout (evita interrumpir justo al pagar).
  if (window.location.pathname.indexOf('/checkout') === 0) return;

  var UMBRAL_ENVIO_GRATIS = 0; // cts. 0 = envío gratis siempre. Debe coincidir con snippets/cart-drawer.liquid
  var TRAMOS_CANTIDAD = [
    { cantidad: 2, pct: 10 },
    { cantidad: 3, pct: 15 },
    { cantidad: 4, pct: 20 },
  ];

  function formatearDinero(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  // Con el carrito lateral abierto no debe saltar ningún pop-up encima:
  // se quedaban dos capas a la vez y la tienda parecía bloqueada.
  function carritoAbierto() {
    return !!document.querySelector('cart-drawer.active');
  }

  function mostrarPopupSegunCarrito() {
    if (yaMostradoEnSesion() || carritoAbierto()) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (yaMostradoEnSesion() || carritoAbierto()) return;
      if (cart.item_count > 0) {
        var texto = popupCarrito.querySelector('[data-sn-popup-carrito-texto]');
        var barraWrap = popupCarrito.querySelector('[data-sn-popup-carrito-barra]');
        var relleno = popupCarrito.querySelector('[data-sn-popup-carrito-relleno]');
        var falta = UMBRAL_ENVIO_GRATIS - cart.total_price;
        var lineas = [];
        if (falta > 0) {
          lineas.push('Te faltan ' + formatearDinero(falta) + ' para el envío gratis.');
          if (barraWrap) barraWrap.hidden = false;
          if (relleno) relleno.style.width = Math.min(100, (cart.total_price * 100) / UMBRAL_ENVIO_GRATIS) + '%';
        } else {
          lineas.push('Ya tienes envío gratis en tu pedido.');
          if (barraWrap) barraWrap.hidden = true;
        }
        var siguienteTramo = TRAMOS_CANTIDAD.find(function (t) { return t.cantidad === cart.item_count + 1; });
        if (siguienteTramo) {
          lineas.push('Añade 1 más y ahorra un ' + siguienteTramo.pct + '%.');
        }
        if (texto) texto.textContent = lineas.join(' ');
        abrir(popupCarrito);
        marcarMostradoEnSesion();
      } else {
        if (yaSuscrita() || enPausa()) return;
        abrir(popupBienvenida);
        marcarMostradoEnSesion();
      }
    }).catch(function () {});
  }

  // Exit-intent de escritorio: el ratón sale por arriba de la ventana.
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && !e.toElement && e.clientY <= 0) {
      mostrarPopupSegunCarrito();
    }
  });

  // Intención de salida en móvil: no existe "el ratón sale de la pantalla",
  // así que se usa el gesto real más parecido — pulsar "atrás" del
  // navegador. Se empuja un estado extra al entrar para poder capturarlo.
  if (window.innerWidth < 900) {
    try {
      history.pushState({ snPopupGuard: true }, '');
      window.addEventListener('popstate', function () {
        mostrarPopupSegunCarrito();
      }, { once: true });
    } catch (e) {}
  }

  // Red de seguridad para captación (carrito vacío): si nadie ha disparado
  // el exit-intent, se ofrece igualmente tras un rato de navegación real
  // (tiempo o scroll, lo que llegue antes) — nunca en visitantes con
  // carrito, ni ya suscritas, ni en pausa.
  var redSeguridadDisparada = false;
  function redSeguridad() {
    if (redSeguridadDisparada || carritoAbierto() || yaMostradoEnSesion() || yaSuscrita() || enPausa()) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count > 0 || carritoAbierto()) return;
      redSeguridadDisparada = true;
      abrir(popupBienvenida);
      marcarMostradoEnSesion();
    }).catch(function () {});
  }
  setTimeout(redSeguridad, 5000);
  window.addEventListener('scroll', function () {
    var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight || 1)) * 100;
    if (pct >= 60) redSeguridad();
  }, { passive: true });
}

/* ------------------------------------------------------------
   Notificaciones (toasts) — solo eventos reales del carrito, nunca
   actividad de otras clientas inventada.
------------------------------------------------------------ */
function initToasts() {
  var UMBRAL_ENVIO_GRATIS = 0;
  var contenedor = document.querySelector('[data-sn-toasts]');
  if (!contenedor) return;

  function mostrarToast(mensaje) {
    var toast = document.createElement('div');
    toast.className = 'sn-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = mensaje;
    contenedor.appendChild(toast);
    requestAnimationFrame(function () { toast.setAttribute('data-sn-visible', ''); });
    setTimeout(function () {
      toast.removeAttribute('data-sn-visible');
      setTimeout(function () { toast.remove(); }, 250);
    }, 4000);
  }

  var totalAnterior = null;
  var descuentoAnterior = null;

  document.addEventListener('sn:add_to_cart', function (e) {
    var titulo = (e.detail && e.detail.title) || 'tu producto';
    mostrarToast('Añadido al carrito: ' + titulo);

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (totalAnterior !== null && totalAnterior < UMBRAL_ENVIO_GRATIS && cart.total_price >= UMBRAL_ENVIO_GRATIS) {
        mostrarToast('Envío gratis desbloqueado.');
      }
      if (descuentoAnterior !== null && cart.total_discount > descuentoAnterior) {
        mostrarToast('Descuento aplicado: -' + (cart.total_discount / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }));
      }
      totalAnterior = cart.total_price;
      descuentoAnterior = cart.total_discount;
    }).catch(function () {});
  });

  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    totalAnterior = cart.total_price;
    descuentoAnterior = cart.total_discount;
  }).catch(function () {});
}

function initCartTimer() {
  var CLAVE = 'sn_reserva_carrito_hasta';
  var DURACION_MS = 10 * 60 * 1000;
  var intervalo = null;

  function formatear(ms) {
    var totalSeg = Math.max(0, Math.ceil(ms / 1000));
    var min = Math.floor(totalSeg / 60);
    var seg = totalSeg % 60;
    return min + ':' + (seg < 10 ? '0' : '') + seg;
  }

  function mostrar(restanteMs) {
    var contenedor = document.getElementById('sn-cart-timer');
    var valorEl = document.getElementById('sn-cart-timer-valor');
    if (contenedor) contenedor.style.display = '';
    if (valorEl) valorEl.textContent = formatear(restanteMs);
  }

  function ocultar() {
    if (intervalo) {
      clearInterval(intervalo);
      intervalo = null;
    }
    try {
      localStorage.removeItem(CLAVE);
    } catch (e) {}
    var contenedor = document.getElementById('sn-cart-timer');
    if (contenedor) contenedor.style.display = 'none';
  }

  function tick() {
    var hasta = parseInt(localStorage.getItem(CLAVE) || '0', 10);
    var restante = hasta - Date.now();
    if (!hasta || restante <= 0) {
      ocultar();
      return;
    }
    mostrar(restante);
  }

  function iniciar() {
    var hasta = Date.now() + DURACION_MS;
    try {
      localStorage.setItem(CLAVE, String(hasta));
    } catch (e) {}
    mostrar(DURACION_MS);
    if (intervalo) clearInterval(intervalo);
    intervalo = setInterval(tick, 1000);
  }

  // Si ya hay una reserva activa (por ejemplo, al recargar la página con
  // productos en el carrito), retoma la cuenta atrás donde iba.
  var hastaGuardada = parseInt(localStorage.getItem(CLAVE) || '0', 10);
  if (hastaGuardada && hastaGuardada > Date.now()) {
    mostrar(hastaGuardada - Date.now());
    intervalo = setInterval(tick, 1000);
  }

  // El carrito publica este evento tanto al añadir un producto como al
  // cambiar su cantidad; usamos el recuento real que devuelve Shopify
  // (item_count) para saber si sigue habiendo algo que reservar.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      var itemCount = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : null;
      if (itemCount === 0) {
        ocultar();
      } else {
        iniciar();
      }
    });
  }
}

function initToonhub() {
  var roots = document.querySelectorAll('[data-sn-toonhub]');
  roots.forEach(function (outer) {
    var items = Array.prototype.slice.call(outer.querySelectorAll('[data-sn-toonhub-item]'));
    var prevBtn = outer.querySelector('[data-sn-toonhub-prev]');
    var nextBtn = outer.querySelector('[data-sn-toonhub-next]');
    if (!items.length) return;

    var DURATION = 650;
    var EASE = 'cubic-bezier(0.4,0,0.2,1)';
    var itemTransition = 'transform ' + DURATION + 'ms ' + EASE + ', filter ' + DURATION + 'ms ' + EASE +
      ', opacity ' + DURATION + 'ms ' + EASE + ', left ' + DURATION + 'ms ' + EASE;

    var count = items.length;
    var activeIndex = 0;
    var isAnimating = false;
    var isMobile = window.innerWidth < 640;

    items.forEach(function (item) {
      var preload = new Image();
      preload.src = item.getAttribute('data-src');
    });

    function roleFor(index) {
      if (index === activeIndex) return 'center';
      if (index === (activeIndex + count - 1) % count) return 'left';
      if (index === (activeIndex + 1) % count) return 'right';
      return 'back';
    }

    function styleFor(role) {
      if (role === 'center') {
        return {
          left: '50%',
          transform: 'translateX(-50%) scale(' + (isMobile ? 1.25 : 1.68) + ')',
          filter: 'blur(0px)',
          opacity: '1',
          zIndex: '20',
          height: isMobile ? '60%' : '92%',
          bottom: isMobile ? '22%' : '0',
        };
      }
      if (role === 'left') {
        return {
          left: isMobile ? '20%' : '30%',
          transform: 'translateX(-50%) scale(1)',
          filter: 'blur(2px)',
          opacity: '0.85',
          zIndex: '10',
          height: isMobile ? '16%' : '28%',
          bottom: isMobile ? '32%' : '12%',
        };
      }
      if (role === 'right') {
        return {
          left: isMobile ? '80%' : '70%',
          transform: 'translateX(-50%) scale(1)',
          filter: 'blur(2px)',
          opacity: '0.85',
          zIndex: '10',
          height: isMobile ? '16%' : '28%',
          bottom: isMobile ? '32%' : '12%',
        };
      }
      return {
        left: '50%',
        transform: 'translateX(-50%) scale(1)',
        filter: 'blur(4px)',
        opacity: '1',
        zIndex: '5',
        height: isMobile ? '13%' : '22%',
        bottom: isMobile ? '32%' : '12%',
      };
    }

    function render() {
      outer.style.backgroundColor = items[activeIndex].getAttribute('data-bg');
      items.forEach(function (item, index) {
        var s = styleFor(roleFor(index));
        item.style.transition = itemTransition;
        item.style.willChange = 'transform, filter, opacity';
        item.style.left = s.left;
        item.style.transform = s.transform;
        item.style.filter = s.filter;
        item.style.opacity = s.opacity;
        item.style.zIndex = s.zIndex;
        item.style.height = s.height;
        item.style.bottom = s.bottom;
      });
    }

    function navigate(direction) {
      if (isAnimating) return;
      isAnimating = true;
      activeIndex = direction === 'next' ? (activeIndex + 1) % count : (activeIndex + count - 1) % count;
      render();
      setTimeout(function () { isAnimating = false; }, DURATION);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { navigate('prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { navigate('next'); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = window.innerWidth < 640;
        if (nowMobile !== isMobile) {
          isMobile = nowMobile;
          render();
        }
      }, 100);
    });

    render();
  });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-sn-producto]');
  if (!wrap) return;
  var mainImg = wrap.querySelector('#sn-galeria-principal-img');
  var thumbs = wrap.querySelectorAll('[data-sn-thumb]');
  if (!mainImg || !thumbs.length) return;
  var contador = wrap.querySelector('[data-sn-foto-actual]');
  var tira = wrap.querySelector('.sn-prod-galeria-miniaturas');
  function activar(i) {
    var thumb = thumbs[i];
    if (!thumb) return;
    mainImg.src = thumb.getAttribute('data-full');
    thumbs.forEach(function (t) { t.classList.remove('is-activo'); t.setAttribute('aria-current', 'false'); });
    thumb.classList.add('is-activo');
    thumb.setAttribute('aria-current', 'true');
    if (contador) contador.textContent = i + 1;
    if (tira) {
      var izq = thumb.offsetLeft - tira.offsetLeft;
      if (izq < tira.scrollLeft || izq + thumb.offsetWidth > tira.scrollLeft + tira.clientWidth) {
        tira.scrollTo({ left: Math.max(0, izq - 12), behavior: 'smooth' });
      }
    }
  }
  function indiceActual() {
    for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-activo')) return i; }
    return 0;
  }
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { activar(i); });
  });
  var prev = wrap.querySelector('[data-sn-foto-prev]');
  var next = wrap.querySelector('[data-sn-foto-next]');
  if (prev) prev.addEventListener('click', function () { activar((indiceActual() - 1 + thumbs.length) % thumbs.length); });
  if (next) next.addEventListener('click', function () { activar((indiceActual() + 1) % thumbs.length); });
}

function initVariantesProducto() {
  var wrap = document.querySelector('[data-sn-producto]');
  if (!wrap) return;
  var dataEl = document.getElementById('sn-variantes-data');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var optionGroups = wrap.querySelectorAll('[data-sn-opcion]');
  if (!optionGroups.length) return;

  var selected = [];
  optionGroups.forEach(function (group) {
    var active = group.querySelector('.sn-opcion-valor.is-activo') || group.querySelector('.sn-opcion-valor');
    selected.push(active ? active.getAttribute('data-valor') : null);
  });

  function findVariant() {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val === null || opts[i] === val; });
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    var idInput = document.getElementById('sn-variant-id');
    var precio = document.getElementById('sn-precio');
    var precioAntes = document.getElementById('sn-precio-antes');
    var precioPct = document.getElementById('sn-precio-pct');
    var badgeRebaja = document.getElementById('sn-badge-rebaja');
    var badgePct = document.getElementById('sn-badge-porcentaje');
    var btn = document.getElementById('sn-btn-comprar');
    var btnTexto = document.getElementById('sn-btn-comprar-texto');
    if (idInput) idInput.value = variant.id;
    if (precio) precio.textContent = formatMoney(variant.price);
    var enRebaja = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (precio) precio.classList.toggle('is-rebaja', !!enRebaja);
    var pct = enRebaja ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
    if (precioAntes) {
      precioAntes.style.display = enRebaja ? '' : 'none';
      precioAntes.textContent = enRebaja ? formatMoney(variant.compare_at_price) : '';
    }
    if (precioPct) {
      precioPct.style.display = enRebaja ? '' : 'none';
      precioPct.textContent = enRebaja ? ('-' + pct + '%') : '';
    }
    var precioAhorro = document.getElementById('sn-precio-ahorro');
    if (precioAhorro) {
      precioAhorro.style.display = enRebaja ? '' : 'none';
      precioAhorro.textContent = enRebaja ? ('Ahorras ' + formatMoney(variant.compare_at_price - variant.price)) : '';
    }
    if (badgeRebaja) badgeRebaja.style.display = enRebaja ? '' : 'none';
    if (badgePct) badgePct.textContent = enRebaja ? ('-' + pct + '%') : '';
    if (btn) {
      btn.disabled = !variant.available;
    }
    if (btnTexto) {
      btnTexto.textContent = variant.available
        ? (btn.getAttribute('data-texto-disponible') || btnTexto.textContent)
        : (btn.getAttribute('data-texto-agotado') || 'Agotado');
    }
    var badgeStockBajo = document.getElementById('sn-badge-stock-bajo');
    if (badgeStockBajo) {
      var umbral = parseInt(badgeStockBajo.getAttribute('data-umbral'), 10) || 0;
      var activo = badgeStockBajo.getAttribute('data-activo') === 'true';
      var pocasUnidades = false;
      if (activo && variant.available) {
        pocasUnidades = variant.inventory_management === 'shopify'
          ? (variant.inventory_quantity > 0 && variant.inventory_quantity <= umbral)
          : true;
      }
      badgeStockBajo.style.display = pocasUnidades ? '' : 'none';
    }
    if (variant.featured_media) {
      var mainImg = wrap.querySelector('#sn-galeria-principal-img');
      var thumbs = wrap.querySelectorAll('[data-sn-thumb]');
      var match = null;
      thumbs.forEach(function (t) {
        if (String(t.getAttribute('data-media-id')) === String(variant.featured_media.id)) match = t;
      });
      if (match) match.click();
    }
    var stickyVariante = document.getElementById('sn-sticky-variante');
    var stickyBtn = document.getElementById('sn-sticky-btn');
    if (stickyVariante) stickyVariante.textContent = variant.title === 'Default Title' ? '' : variant.title;
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available
        ? (btnTexto ? btnTexto.getAttribute('data-texto-disponible') || btnTexto.textContent : 'Añadir al carrito')
        : (btn ? btn.getAttribute('data-texto-agotado') || 'Agotado' : 'Agotado');
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  optionGroups.forEach(function (group, i) {
    var buttons = group.querySelectorAll('.sn-opcion-valor');
    var elegido = wrap.querySelector('[data-sn-valor-elegido="' + i + '"]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[i] = btn.getAttribute('data-valor');
        buttons.forEach(function (b) {
          b.classList.remove('is-activo');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-activo');
        btn.setAttribute('aria-pressed', 'true');
        if (elegido) elegido.textContent = selected[i];
        applyVariant(findVariant());
      });
    });
  });
}

/* ------------------------------------------------------------
   Widget de urgencia: contador de "personas viendo esto ahora
   mismo" SIMULADO a petición del usuario (no lee tráfico real).
   Cada 5s sube o baja de 1 en 1 (paseo aleatorio), sin saltos,
   dentro del rango del widget (por defecto 20-50, configurable
   desde el editor).
------------------------------------------------------------ */
function initVisitasSimuladas() {
  var els = document.querySelectorAll('[data-sn-contador-visitas]');
  if (!els.length) return;
  els.forEach(function (contador) {
    var widget = contador.closest('[data-sn-widget-urgencia]');
    var min = parseInt((widget && widget.getAttribute('data-min')) || '20', 10);
    var max = parseInt((widget && widget.getAttribute('data-max')) || '50', 10);
    if (isNaN(min)) min = 20;
    if (isNaN(max) || max < min) max = min + 30;
    var actual = Math.floor(Math.random() * (max - min + 1)) + min;
    contador.textContent = actual;
    setInterval(function () {
      var paso = Math.random() < 0.5 ? -1 : 1;
      actual += paso;
      if (actual < min) actual = min + 1;
      if (actual > max) actual = max - 1;
      contador.textContent = actual;
    }, 5000);
  });
}

function initContadorOferta() {
  var els = document.querySelectorAll('[data-sn-contador-oferta]');
  if (!els.length) return;
  els.forEach(function (el) {
    var fin = el.getAttribute('data-fin');
    if (!fin) return;
    var finMs = new Date(fin).getTime();
    if (isNaN(finMs)) return;
    var dias = el.querySelector('[data-sn-contador-dias]');
    var horas = el.querySelector('[data-sn-contador-horas]');
    var min = el.querySelector('[data-sn-contador-min]');
    var seg = el.querySelector('[data-sn-contador-seg]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var restante = finMs - Date.now();
      if (restante <= 0) {
        el.hidden = true;
        clearInterval(intervalo);
        return;
      }
      el.hidden = false;
      var s = Math.floor(restante / 1000);
      if (dias) dias.textContent = pad(Math.floor(s / 86400));
      if (horas) horas.textContent = pad(Math.floor((s % 86400) / 3600));
      if (min) min.textContent = pad(Math.floor((s % 3600) / 60));
      if (seg) seg.textContent = pad(s % 60);
    }
    tick();
    var intervalo = setInterval(tick, 1000);
  });
}

function initVistosRecientemente() {
  var wrap = document.querySelector('[data-sn-vistos]');
  if (!wrap) return;
  var actualEl = document.querySelector('[data-sn-vistos-actual]');
  var lista;
  try { lista = JSON.parse(localStorage.getItem('sn_vistos') || '[]'); } catch (e) { lista = []; }

  var actualDatos = null;
  if (actualEl) {
    try { actualDatos = JSON.parse(actualEl.textContent); } catch (e) {}
  }
  if (actualDatos && actualDatos.handle) {
    lista = lista.filter(function (p) { return p.handle !== actualDatos.handle; });
    lista.unshift(actualDatos);
    lista = lista.slice(0, 8);
    try { localStorage.setItem('sn_vistos', JSON.stringify(lista)); } catch (e) {}
  }

  var otros = lista.filter(function (p) { return !actualDatos || p.handle !== actualDatos.handle; });
  if (!otros.length) { wrap.hidden = true; return; }

  var track = wrap.querySelector('[data-sn-vistos-track]');
  if (!track) return;
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  otros = otros.filter(function (p) { return p && p.image; });
  if (!otros.length) return;
  track.innerHTML = otros.map(function (p) {
    return '<a href="' + esc(p.url) + '" class="sn-vistos-card">' +
      '<img class="sn-vistos-img" src="' + esc(p.image).replace(/"/g, '&quot;') + '" alt="" loading="lazy" width="150" height="188">' +
      '<p class="sn-vistos-titulo">' + esc(p.title) + '</p>' +
      '<p class="sn-vistos-precio">' + esc(p.precio) + '</p>' +
      '</a>';
  }).join('');
  wrap.hidden = false;
}

function initCantidadProducto() {
  var wrap = document.querySelector('[data-sn-cantidad]');
  if (!wrap) return;
  var input = wrap.querySelector('.sn-cantidad-input');
  var menos = wrap.querySelector('[data-sn-cantidad-menos]');
  var mas = wrap.querySelector('[data-sn-cantidad-mas]');
  if (!input || !menos || !mas) return;

  function setValue(v) {
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var next = Math.max(min, v);
    input.value = next;
  }

  menos.addEventListener('click', function () {
    setValue((parseInt(input.value, 10) || 1) - 1);
  });
  mas.addEventListener('click', function () {
    setValue((parseInt(input.value, 10) || 1) + 1);
  });
  input.addEventListener('change', function () {
    setValue(parseInt(input.value, 10) || 1);
  });
}

function initStickyCompra() {
  var bar = document.querySelector('[data-sn-sticky-compra]');
  var mainBtn = document.getElementById('sn-btn-comprar');
  if (!bar || !mainBtn) return;

  var stickyBtn = document.getElementById('sn-sticky-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      mainBtn.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    });
  }, { threshold: 0 });
  observer.observe(mainBtn);
}

function initReveals() {
  var els = document.querySelectorAll('.sn-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sn-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.getAttribute('data-sn-delay') || 0;
        setTimeout(function () { el.classList.add('sn-visible'); }, Number(delay));
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initMarquesina() {
  var wraps = document.querySelectorAll('.sn-marquesina');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.sn-marquesina-track');
    if (!track || track.dataset.snDuped) return;
    track.dataset.snDuped = 'true';
    track.innerHTML += track.innerHTML;
  });
}

function initContadores() {
  var counters = document.querySelectorAll('.sn-contador');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString('es-ES');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('es-ES');
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(function (el) { observer.observe(el); });
}

// Carga el vídeo de una diapositiva solo cuando se va a ver, eligiendo la
// versión más ligera que cubra el ancho de la pantalla (en móvil, 480p/720p
// en vez de 1080p).
function snHeroCargarVideo(slide) {
  var video = slide && slide.querySelector('[data-sn-hero-video]');
  if (!video) return;
  if (!video.getAttribute('src')) {
    var fuentes = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
    if (!fuentes.length) return;
    fuentes.sort(function (a, b) { return Number(a.dataset.ancho) - Number(b.dataset.ancho); });
    var necesario = window.innerWidth < 750 ? 480 : window.innerWidth < 1300 ? 1280 : 1920;
    var elegida = fuentes.find(function (f) { return Number(f.dataset.ancho) >= necesario; }) || fuentes[fuentes.length - 1];
    video.src = elegida.dataset.src;
  }
  var p = video.play();
  if (p && p.catch) p.catch(function () {});
}

function initHeroCarousel() {
  var roots = document.querySelectorAll('[data-sn-hero-carousel]');
  roots.forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sn-hero-slide]'));
    snHeroCargarVideo(slides[0]);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sn-hero-dot]'));
    if (slides.length < 2) return;
    var current = 0;
    var intervalMs = Number(root.getAttribute('data-sn-hero-rotate')) || 6000;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('sn-hero-slide--activa');
      if (dots[current]) dots[current].classList.remove('sn-hero-dot--activo');
      current = index;
      slides[current].classList.add('sn-hero-slide--activa');
      if (dots[current]) dots[current].classList.add('sn-hero-dot--activo');
      snHeroCargarVideo(slides[current]);
    }

    function next() { show((current + 1) % slides.length); }

    function start() {
      stop();
      timer = setInterval(next, intervalMs);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });

    start();
  });
}

function initBestsellersCarousel() {
  var sections = document.querySelectorAll('[data-sn-bs-track]');
  sections.forEach(function (track) {
    var wrap = track.closest('.sn-section');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-sn-bs-prev]');
    var nextBtn = wrap.querySelector('[data-sn-bs-next]');
    var step = function () {
      var card = track.querySelector('.sn-bs-card');
      return card ? card.getBoundingClientRect().width + 28 : 320;
    };
    var updateNav = function () {
      if (prevBtn) prevBtn.setAttribute('aria-disabled', track.scrollLeft <= 4 ? 'true' : 'false');
      if (nextBtn) {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    };
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  });
}

/* ------------------------------------------------------------
   Bloqueo de scroll de fondo al abrir el carrito (drawer)
   El tema nativo solo añade la clase "overflow-hidden" al <body>, pero eso
   no basta en móvil: Safari/Chrome siguen permitiendo arrastrar la página
   de fondo (incluido en horizontal) mientras el carrito está abierto. Se
   observa esa clase y, mientras esté activa, se fija también el <html> en
   position:fixed conservando el scroll para restaurarlo al cerrar — así el
   fondo queda realmente inmóvil y solo se puede desplazar el propio carrito.
------------------------------------------------------------ */
function initCartDrawerScrollLock() {
  var root = document.documentElement;
  var scrollY = 0;

  function bloquear() {
    scrollY = window.scrollY;
    root.style.top = '-' + scrollY + 'px';
    root.classList.add('sn-scroll-lock');
  }

  function desbloquear() {
    root.classList.remove('sn-scroll-lock');
    root.style.top = '';
    window.scrollTo(0, scrollY);
  }

  var bloqueado = false;
  new MutationObserver(function () {
    var activo = document.body.classList.contains('overflow-hidden');
    if (activo && !bloqueado) {
      bloqueado = true;
      bloquear();
    } else if (!activo && bloqueado) {
      bloqueado = false;
      desbloquear();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
}

function initCarrito() {
  var form = document.getElementById('sn-cart-form');
  if (!form) return;

  form.addEventListener('click', function (e) {
    var menos = e.target.closest('[data-sn-cart-menos]');
    var mas = e.target.closest('[data-sn-cart-mas]');
    var eliminar = e.target.closest('[data-sn-cart-eliminar-fila]');
    if (menos || mas) {
      var input = (menos || mas).parentElement.querySelector('[data-sn-cart-cantidad]');
      if (!input) return;
      var valor = parseInt(input.value, 10) || 0;
      valor = menos ? Math.max(0, valor - 1) : valor + 1;
      input.value = valor;
      form.submit();
    } else if (eliminar) {
      var fila = eliminar.closest('tr');
      var input = fila ? fila.querySelector('[data-sn-cart-cantidad]') : null;
      if (input) {
        input.value = 0;
        form.submit();
      }
    }
  });
}

/* ------------------------------------------------------------------
   Recomendación en el carrito lateral (snippets/sn-cart-recomendacion.liquid)
   Carrusel de prendas: calcula el ahorro real del siguiente tramo de
   descuento por cantidad para cada prenda, deja elegir color y talla por
   separado (solo combinaciones con stock) y la añade al carrito sin salir
   de la página.
   ------------------------------------------------------------------ */
(function () {
  if (customElements.get('sn-cart-recomendacion')) return;

  function dinero(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  class SnCartRecomendacion extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.carrusel = this.querySelector('[data-sn-reco-carrusel]');
      this.querySelectorAll('[data-sn-reco-slide]').forEach((slide) => {
        slide.variantes = JSON.parse(slide.querySelector('[data-sn-reco-variantes]').textContent);
        slide.selects = Array.prototype.slice.call(slide.querySelectorAll('[data-sn-reco-opcion]'));
        // Orden original de los valores de cada opción, para reconstruir las listas.
        slide.valores = slide.selects.map(function (select) {
          return Array.prototype.map.call(select.options, function (o) { return o.value; });
        });
        slide.selects.forEach((select) => {
          select.addEventListener('change', () => this.actualizar(slide));
        });
        slide.querySelector('[data-sn-reco-boton]').addEventListener('click', () => this.anadir(slide));
        this.actualizar(slide);
      });
      this.querySelectorAll('[data-sn-reco-flecha]').forEach((flecha) => {
        flecha.addEventListener('click', () => {
          var slide = this.carrusel.querySelector('[data-sn-reco-slide]');
          var paso = slide.getBoundingClientRect().width + 12;
          this.carrusel.scrollBy({ left: paso * Number(flecha.dataset.snRecoFlecha), behavior: 'smooth' });
        });
      });
    }

    // Deja en cada lista solo los valores con stock para lo ya elegido antes
    // (p. ej. las tallas disponibles del color marcado) y devuelve la variante.
    elegir(slide) {
      var candidatas = slide.variantes;
      slide.selects.forEach(function (select, i) {
        var disponibles = slide.valores[i].filter(function (valor) {
          return candidatas.some(function (v) { return v.opciones[i] === valor; });
        });
        var actual = disponibles.indexOf(select.value) === -1 ? disponibles[0] : select.value;
        select.textContent = '';
        disponibles.forEach(function (valor) {
          var opcion = document.createElement('option');
          opcion.value = valor;
          opcion.textContent = valor;
          select.appendChild(opcion);
        });
        select.value = actual;
        candidatas = candidatas.filter(function (v) { return v.opciones[i] === actual; });
      });
      return candidatas[0] || slide.variantes[0];
    }

    actualizar(slide) {
      var variante = this.elegir(slide);
      slide.variante = variante;
      slide.querySelector('[data-sn-reco-precio]').textContent = variante.precioTexto;
      var antes = slide.querySelector('[data-sn-reco-antes]');
      antes.textContent = variante.antesTexto;
      antes.hidden = !variante.antesTexto;
      // La foto sigue al color elegido (si esa variante tiene foto propia).
      var img = slide.querySelector('[data-sn-reco-img]');
      if (img && variante.imagen && img.getAttribute('src') !== variante.imagen) img.src = variante.imagen;

      var pct = Number(this.dataset.pct);
      var ahorro;
      var envio = '';
      if (this.dataset.soloPrenda) {
        // Con 4 o más prendas el 20% ya está aplicado: solo se ahorra en esta prenda.
        ahorro = Math.floor((variante.precio * pct) / 100);
      } else {
        // Ahorro real del pedido completo con el tramo que se alcanza al añadirla.
        var subtotal = Number(this.dataset.subtotal) + variante.precio;
        ahorro = Math.floor((subtotal * pct) / 100);
        var umbral = Number(this.dataset.umbralEnvio);
        if (Number(this.dataset.total) < umbral && subtotal - ahorro >= umbral && this.dataset.textoEnvio) {
          envio = ' ' + this.dataset.textoEnvio;
        }
      }
      var texto = (this.dataset.textoAhorro || '').replace('[ahorro]', dinero(ahorro));
      slide.querySelector('[data-sn-reco-ahorro]').textContent = texto ? texto + envio : '';
    }

    anadir(slide) {
      var carrito = document.querySelector('cart-drawer');
      var boton = slide.querySelector('[data-sn-reco-boton]');
      var error = this.querySelector('[data-sn-reco-error]');
      error.hidden = true;
      boton.disabled = true;
      var cuerpo = { items: [{ id: slide.variante.id, quantity: 1 }] };
      if (carrito) {
        cuerpo.sections = carrito.getSectionsToRender().map(function (s) { return s.id; });
        cuerpo.sections_url = window.location.pathname;
      }
      fetch(this.dataset.urlAnadir + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo),
      })
        .then(function (r) { return r.json(); })
        .then((respuesta) => {
          if (respuesta.status || !respuesta.sections) throw new Error(respuesta.description || 'error');
          // Repinta el carrito entero: aviso, ahorro, total y el carrusel sin la prenda añadida.
          carrito.renderContents(respuesta);
        })
        .catch(() => {
          error.textContent = this.dataset.textoError;
          error.hidden = false;
          boton.disabled = false;
        });
    }
  }

  customElements.define('sn-cart-recomendacion', SnCartRecomendacion);
})();
